import React from 'react';

import DialogActions from '@mui/material/DialogActions';

import i18n from 'i18next';
import Button from 'components/buttons/Button';
import Dialog from './Dialog';

type Props = {
   open?: boolean;
   content?: React.ReactNode;
   title?: string;
   confirmLabel?: string;
   cancelLabel?: string;
   onOk?: () => void;
   onCancel?: () => void;
};
export const ConfirmationDialog = (props: Props) => {
   const {
      open = true,
      content = i18n.t('Proceed?') as React.ReactNode,
      title = i18n.t('Confirmation'),
      confirmLabel = 'Ok', // TODO i18n.t('Ok'),
      cancelLabel = 'Cancel', // TODO i18n.t('Cancel'),
      onOk,
      onCancel,
   } = props;

   return (
      <Dialog open={open} header={title} close={onCancel}>
         {content}
         <DialogActions>
            <Button onClick={onOk} color="primary">
               {confirmLabel}
            </Button>
            <Button autoFocus onClick={onCancel} color="primary">
               {cancelLabel}
            </Button>
         </DialogActions>
      </Dialog>
   );
};
